import { settingsMenuItem } from '@/shared/constants';
import { checkPermissions } from '@/shared/utils';
import { Link, useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

interface SidebarSettingsLinkProps {
  isExpanded: boolean;
  onMenuClick: () => void;
}

export function SidebarSettingsLink({
  isExpanded,
  onMenuClick,
}: SidebarSettingsLinkProps) {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;
  const isSettingsActive = currentPath.startsWith('/settings');
  const SettingsIcon = settingsMenuItem.icon;
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const verifyPermissions = async () => {
      const hasAccess = await checkPermissions(['identity.users.read']);
      setHasPermission(hasAccess);
    };

    verifyPermissions();
  }, []);

  if (!hasPermission) {
    return null;
  }

  return (
    <nav className='sidebar-menu'>
      <Link
        to={settingsMenuItem.id}
        data-active={isSettingsActive ? 'true' : undefined}
        onClick={onMenuClick}
        className={`
          relative w-full h-10 rounded-md flex items-center gap-3 transition-all duration-300 ease-in-out
          ${isExpanded ? 'px-3' : 'px-2.5'}
          ${
            isSettingsActive
              ? 'bg-alba-green-500 text-white shadow-lg shadow-alba-green-500/30'
              : 'text-white hover:bg-alba-blue-700'
          }
        `}
      >
        <SettingsIcon className='w-5 h-5 flex-shrink-0' strokeWidth={1.6} />
        <span
          className={`transition-opacity duration-300 whitespace-nowrap text-sm font-medium overflow-hidden ${
            isExpanded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {settingsMenuItem.label}
        </span>
      </Link>
    </nav>
  );
}
